// "Sign in with Google" button — follows Google's official identity guidelines.
// https://developers.google.com/identity/branding-guidelines
//
// Variants:
//   - "light" (white bg, dark text): for use on dark backgrounds — our default
//   - "dark"  (#131314 bg, white text): for use on light backgrounds
//   - "compact": tighter padding for the navbar
//
// The multicolor G is rendered inline as SVG so we never depend on a remote asset.

function GoogleGlyph({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 18 18" aria-hidden="true">
      <path d="M17.64 9.2a10.4 10.4 0 0 0-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.62z" fill="#4285F4"/>
      <path d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.8.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.02-3.7H.92v2.32A9 9 0 0 0 9 18z" fill="#34A853"/>
      <path d="M3.98 10.72A5.4 5.4 0 0 1 3.7 9c0-.6.1-1.18.28-1.72V4.96H.92A9 9 0 0 0 0 9c0 1.45.35 2.82.92 4.04l3.06-2.32z" fill="#FBBC05"/>
      <path d="M9 3.58c1.32 0 2.5.46 3.44 1.35l2.58-2.58A8.97 8.97 0 0 0 9 0 9 9 0 0 0 .92 4.96l3.06 2.32C4.68 5.16 6.66 3.58 9 3.58z" fill="#EA4335"/>
    </svg>
  );
}

const baseLight = "inline-flex items-center justify-center gap-3 bg-white text-[#1f1f1f] border border-[#dadce0] hover:bg-[#f8f9fa] hover:shadow-sm active:bg-[#f1f3f4] font-medium tracking-normal transition-colors rounded-md select-none";
const baseDark  = "inline-flex items-center justify-center gap-3 bg-[#131314] text-white border border-[#8e918f] hover:bg-[#1f1f1f] active:bg-[#0a0a0a] font-medium tracking-normal transition-colors rounded-md select-none";

export default function GoogleSignInButton({
  onClick,
  variant = "light",       // "light" | "dark"
  size = "default",        // "default" | "compact"
  label = "Sign in with Google",
  fullWidth = false,
  testid = "google-signin-btn",
  className = "",
}) {
  const palette = variant === "dark" ? baseDark : baseLight;
  const pad = size === "compact" ? "px-3 py-2 text-sm" : "px-5 py-3 text-[15px]";
  const width = fullWidth ? "w-full" : "";
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testid}
      className={`${palette} ${pad} ${width} ${className}`}
    >
      <GoogleGlyph size={size === "compact" ? 16 : 18} />
      <span>{label}</span>
    </button>
  );
}
